import { Coffee } from "lucide-react";

export default function EmptyState() {
  return (
    <div
      className="empty-message-view"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        opacity: 0,
        animation: 'emptyFadeIn 200ms ease forwards',
      }}
    >
      <Coffee
        size={64}
        strokeWidth={1.2}
        style={{ color: 'var(--primary)', opacity: 0.6 }}
      />
      <div style={{ textAlign: 'center' }}>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: 'var(--text-base, 15px)',
          margin: '0 0 4px 0',
          fontWeight: 500,
        }}>
          Selecciona un correo para leer
        </p>
        <p style={{
          color: 'var(--text-tertiary)',
          fontSize: 'var(--text-sm, 13px)',
          margin: 0,
        }}>
          o compone uno nuevo
        </p>
      </div>
      <style>{`
        @keyframes emptyFadeIn {
          from { opacity: 0; transform: translateY(4px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
